import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import Button from '@material-ui/core/Button';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  signInTextField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: '100%',
  },
  button: {
    marginTop: theme.spacing.unit * 4,
  },
  forgotPw: {
    marginLeft: 10,
  },
});

const SignInForm = props => {
  const {
    classes,
    handleSubmit,
    handleChange,
    validateForm,
    handleClick,
  } = props;

  return (
    <form
      onSubmit={handleSubmit}
      className={classes.container}
      noValidate
      autoComplete="off"
    >
      <TextField
        id="email"
        label="Email"
        className={classes.signInTextField}
        margin="normal"
        onChange={handleChange}
      />

      <TextField
        id="password"
        label="Password"
        type="password"
        className={classes.signInTextField}
        margin="normal"
        onChange={handleChange}
      />

      <Button
        variant="raised"
        color="primary"
        className={classes.button}
        type="submit"
        disabled={!validateForm()}
      >
        Sign In
      </Button>
      <Button
        className={`${classes.button} ${classes.forgotPw}`}
        onClick={handleClick}
      >
        Forgot Password?
      </Button>
    </form>
  );
};

export default withStyles(styles)(SignInForm);



// WEBPACK FOOTER //
// ./src/components/SignInForm.js